import {AuthoringGuideLevelModelV1} from 'resources/GeneratedModels/AuthoringGuideLevel/AuthoringGuideLevelModel.v1';
import {extensions} from './authoringGuideLevel.extensions';
import {validators} from './authoringGuideLevel.validators';

AuthoringGuideLevelModelV1.extend(extensions);
AuthoringGuideLevelModelV1.addValidators(validators);

export {AuthoringGuideLevelModelV1};
